import { render, staticRenderFns } from "./PostCreateStudentDataTable.vue?vue&type=template&id=4b9fb702"
import script from "./PostCreateStudentDataTable.vue?vue&type=script&lang=js"
export * from "./PostCreateStudentDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports